import { render, staticRenderFns } from "./packageSwitchStrategy.vue?vue&type=template&id=68e3d3b1&scoped=true"
import script from "./packageSwitchStrategy.vue?vue&type=script&lang=js"
export * from "./packageSwitchStrategy.vue?vue&type=script&lang=js"
import style0 from "./packageSwitchStrategy.vue?vue&type=style&index=0&id=68e3d3b1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e3d3b1",
  null
  
)

export default component.exports